import React from 'react';
import classnames from 'classnames';

const { Fragment } = wp.element;
const { Button, Dashicon } = wp.components;

// https://github.com/WordPress/gutenberg/blob/3450273fe7522101e3809b270c80a7b9a3ebcf3a/packages/compose/src/with-state/README.md
// import { withState } from '@wordpress/compose';
const { __, sprintf } = wp.i18n;

export default class UpsellPanel extends React.Component {
	constructor( props ) {
		super( props );

		this.state = {
			/* importedBasic: false,
			importing: false,
			designLibrary: window.dsgnjs.designLibrary, */
		};
	}

	render() {
		const {
			designsCount,
			importing,
			importedBasic,
			importedPremium,
			errorMessage,
		} = this.props;
		return (
			<Fragment>
				{ ! importedPremium && (
					<div
						className={ classnames( 'design-upsell', { centered: ! designsCount } ) }
					>
						<h3 className="design-upsell__header">
							{ designsCount ?
								sprintf(
									__( 'There are %s designs ready to use in your library.' ),
									designsCount
								) :
								__( 'Hello, you have no designs imported.' ) }
						</h3>

						<ul>
							<li className="design-upsell__item design-library__basic">
								{ ! importedBasic && (
									<Button
										className="design-upsell__cta"
										ref={ x => ( this._button_free_desings = x ) }
										isBusy={ importing }
										isLarge
										isPrimary
										onClick={ () => {
											this._button_free_desings.blur(); // Loading animation isn't working without blur.
											this.props.importThumbnails( 'basic' );
										} }
									>
										<Dashicon icon="download" /> { __( 'Import 50 free designs' ) }
									</Button>
								) }
								{ importedBasic && (
									<span>
										<Dashicon icon="yes" /> { __( 'Free designs imported' ) }
									</span>
								) }
							</li>
							{ importedBasic && (
								<li className="design-upsell__item">
									<a
										href="https://wpdesignhub.com/free/?utm_source=plugin-ui&utm_medium=sidebar&utm_campaign=installer-step-free&utm_campaign=installer-step-free"
										target="_blank"
										rel="noreferrer noopener"
									>
										<Dashicon icon="awards" /> { __( 'Get +50 designs for free' ) }
									</a>
								</li>
							) }
							<li className="design-upsell__item">
								{ importedBasic && ! this.props.premiumUser && (
									<a
										href="https://wpdesignhub.com/pro/?utm_source=plugin-ui&utm_medium=sidebar&utm_campaign=installer-step-pro&utm_campaign=installer-step-pro"
										target="_blank"
										rel="noreferrer noopener"
									>
										<Dashicon icon="unlock" />{ ' ' }
										{ __( 'Get pro subscription, 80% OFF' ) }
									</a>
								) }
								{ this.props.premiumUser && importedBasic && ! importedPremium && (
									<Button
										className="design-upsell__cta"
										isBusy={ importing }
										isLarge
										isPrimary
										ref={ x => ( this._button_premium_desings = x ) }
										onClick={ () => {
											this._button_premium_desings.blur(); // Loading animation isn't working without blur.
											this.props.importThumbnails( 'premium' );
										} }
									>
										<Dashicon icon="download" /> { __( 'Import premium designs' ) }
									</Button>
								) }
								{ importedPremium && this.props.premiumUser && (
									<span>
										<Dashicon icon="yes" /> { __( 'Premium designs imported' ) }
									</span>
								) }
							</li>
						</ul>

						{ errorMessage && (
							<div className="design-upsell__errors">
								<p>{ errorMessage }</p>
							</div>
						) }
					</div>
				) }
			</Fragment>
		);
	}
}

// export default Designs



// WEBPACK FOOTER //
// ./src/upsell-panel.jsx